import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';

@Component({
  selector: 'app-front-end-form',
  templateUrl: './front-end-form.component.html',
  providers: [CommonVerbsApiService],
})
export class FrontEndFormComponent {
  @Input() titlePosition: string;
  contactForm = new FormGroup({
    firstName: new FormControl(null, [Validators.required]),
    lastName: new FormControl(null, [Validators.required]),
    phone: new FormControl(null, [
      Validators.pattern('^[0-9]*$'),
      Validators.required,
    ]),
    email: new FormControl(null, [Validators.email, Validators.required]),
    jobTitle: new FormControl(null),
    companyName: new FormControl(null),
    hqState: new FormControl(null),
    message: new FormControl(null),
  });

  isSentInd = false;

  constructor(private api: CommonVerbsApiService) {}

  onSubmit() {
    this.api
      .post(`helper/send-email`, this.contactForm.getRawValue())
      .subscribe(() => {
        this.isSentInd = true;
      });
  }
}
